import PowerBIEmbedComponent from '../../components/PowerBIEmbed';
import './PowerBIDashboard.css';

function PowerBIDashboard() {
  const powerBIConfig = {
    embedUrl: 'https://app.powerbi.com/view?r=eyJrIjoiYTc0NGMwMzMtMzA0NC00ZjBkLWJhYzItZjA5ZDQwZDYxODFiIiwidCI6Ijg1ZmQzZjk0LTk1NGQtNDVhOC05YWQ2LWI1MzM2MjJkZGQzOCJ9'
  };

  return (
    <div className="powerbi-dashboard-container">
      <div className="powerbi-dashboard-header">
        <h1 className="powerbi-dashboard-title">Análisis con Power BI</h1>
      </div>

      <div className="powerbi-dashboard-content">
        <div className="powerbi-embed-section">
          <PowerBIEmbedComponent embedUrl={powerBIConfig.embedUrl} />
        </div>
      </div>
    </div>
  );
}

export default PowerBIDashboard;
